import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_HOSPITAL_BY_ID = 'GET_HOSPITAL_BY_ID';
export const GET_HOSPITAL_BY_ID_SUCCESS = 'GET_HOSPITAL_BY_ID_SUCCESS';
export const GET_HOSPITAL_BY_ID_FAIL = 'GET_HOSPITAL_BY_ID_FAIL';
export const GET_HOSPITAL_BY_ID_RESET = 'GET_HOSPITAL_BY_ID_RESET';

export const getHospitalById = (params) => {
	return {
		type: GET_HOSPITAL_BY_ID,
		params,
	};
};

export const getHospitalByIdSuccess = (response) => {
	return {
		type: GET_HOSPITAL_BY_ID_SUCCESS,
		response,
	};
};

export const getHospitalByIdFail = (response) => {
	return {
		type: GET_HOSPITAL_BY_ID_FAIL,
		response,
	};
};

export const getHospitalByIdReset = () => {
	return {
		type: GET_HOSPITAL_BY_ID_RESET,
	};
};

export const getHospitalByIdApi = (data) => {
	return (dispatch) => {
		dispatch(getHospitalById());
		axios
			.get(`${config.api.base_url}/hospitals/${data.id}`, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getHospitalByIdData = response.data;
				dispatch(getHospitalByIdSuccess(getHospitalByIdData));
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch(getHospitalByIdFail(errorMsg));
			});
	};
};
